export default "__VITE_ASSET__B6tohJ0G__"